import { Box, CheckBox } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { FC } from 'react'

const renderList = (checkboxData: any, setCheckboxData: any) => {
  return checkboxData?.map((item: any) => {
    return (
      <Box marginRight={20} key={getRandomAlphaNumString(3)}>
        <CheckBox
          checked={item.isChecked}
          onChange={() => {
            setCheckboxData(item.text, !item.isChecked)
          }}
          iconSize={18}
          color={item.isChecked ? 'BLUE' : 'BLACK_LIGHT'}
          textLabel={item.text}
          textColor="DARK_GREY"
          fontWeight={'BOLD'}
          fontSize={14}
        />
      </Box>
    )
  })
}
const CheckboxList: FC = ({ checkboxData, setCheckboxData, flexDirection = 'row' }: any) => {
  return (
    <Box
      marginLeft={50}
      marginRight={20}
      alignItems="center"
      height="50"
      flexDirection={flexDirection}
      overflow={'auto'}>
      {renderList(checkboxData, setCheckboxData)}
    </Box>
  )
}

export { CheckboxList }
